module.exports = __webpack_public_path__ + "img/table-tennis-paddle-ball.1c079ed2.svg";